import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

export const EloFilterDownIcon: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M10 13L16 7H4L10 13Z' fill='currentColor' />
  </EloBaseIcon>
)
